import { useMatch } from '@xing-com/crate-core-router';
import { XING_JOBS_SEARCH_KI_PATH } from '@xing-com/crate-core-routes';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useSerpsMatch } from '@xing-com/crate-jobs-domain-serps-hooks';

export const useIsAiSearch = (): boolean => {
  const { isLoggedOut } = useLoginState();
  const serpData = useSerpsMatch();
  const isSerp = Boolean(isLoggedOut && serpData);
  const isAiSearchUrl = !!useMatch(XING_JOBS_SEARCH_KI_PATH);

  return isSerp || isAiSearchUrl;
};
